import { Button, Modal, Form, Dropdown } from 'semantic-ui-react'
import SearchComponent from '../Search'
import { useState } from 'react'
import { suridataApi } from '../../../services/api'
import { toast } from 'react-toastify'


export default function ModalAdd({ modalVisible, setModalVisible, companies, refreshCredentials }){
    const [formData,  setFormData] = useState({
        company_id: '',
        operations: '',
        username: '',
        password: '',
        complement: '',
    })
    const [error, setError] = useState({
        company_id: false,
        operations: false,
        username: false,
        password: false,
        complement: false,
    })

    const operations = [
        'premio', 
        'sinistro', 
        'sinistralidade', 
        'senhas'
    ].map(e => ({
        key: e,
        text: e.charAt(0).toUpperCase() + e.slice(1),
        value: e
    }))

    function handleError() {
        Object.keys(formData).map(key => {
            if(!formData[key]){
                setError(prev => ({...prev, [key]: true}))
            }
        })
    }

    function handleChangeEachField(field, value) {
        setError(prev => ({...prev, [field]: false}))
        setFormData(prev => ({...prev, [field]: value}))
    }

    function handleConfirm() {
        handleError()

        setModalVisible(false)
        toast.promise(
            suridataApi.post('credentials', formData),
            {
                pending: 'Adicionando credencial...',
                success: 'Credencial adicionada!',
                error: 'Ocorreu um erro ao adicionar a credencial'
            }
        )
    }

    return (
        <Modal
            open={modalVisible}
            dimmer='blurring'
            style={{position: 'relative', height: 'auto', maxWidth: '500px'}}
            as={Form}
            onSubmit={handleConfirm}
        >
            <Modal.Header>Adicionar credencial</Modal.Header>
            <Modal.Content >
                <Form.Field error={error.company_id} width={10}>
                    <label>Empresa</label>
                    <SearchComponent
                        options={companies}
                        groupBy='operator'
                        searchBy='name'
                        as={Form.Field}
                        onSelectOption={e => handleChangeEachField('company_id', e.id)}
                    />
                </Form.Field>
                <Form.Field error={error.operations}>
                    <label>Operações</label>
                    <Dropdown
                        placeholder='Selecione...'
                        fluid
                        multiple
                        search
                        selection
                        options={operations}
                        onChange={(e, data) => handleChangeEachField('operations', data.value)}
                    />
                </Form.Field>
                <Form.Field error={error.username} width={12}>
                    <label>Usuário</label>
                    <Form.Input 
                        name="username" 
                        placeholder='Usuário'
                        onChange={e => handleChangeEachField('username', e.target.value)}
                    />
                </Form.Field>
                <Form.Field error={error.password} width={8}>
                    <label>Senha</label>
                    <Form.Input 
                        name="password" 
                        placeholder='Senha'
                        onChange={e => handleChangeEachField('password', e.target.value)}
                    />
                </Form.Field>
                <Form.Field error={error.complement} width={6}>
                    <label>Complemento</label>
                    <Form.Input 
                        name="complement" 
                        placeholder='Complemento'
                        onChange={e => handleChangeEachField('complement', e.target.value)}
                    />
                </Form.Field>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setModalVisible(false)}>Cancelar</Button>
                <Button positive>Adicionar</Button>
            </Modal.Actions>
        </Modal>
    )
}

